import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { farmUpdateAction } from "../../../modules/farmManagement/action";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import SubFarmForm from "./SubFarmForm";

class EditSubFarm extends Component {
  state = { successMessage: "" };

  handleSubmit = farmInfo => {
    farmInfo.id = this.props.selectedFarm.id;
    this.props.farmUpdateAction(farmInfo);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.farmUpdated && nextProps.farmUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  getMainFarmName = MainFarmId => {
    let farm = this.props.MainFarmsList.filter(farm => farm.id === MainFarmId);
    return farm[0] && farm[0].name;
  };

  render() {
    const { successMessage } = this.state;
    if (successMessage) {
      if (isSuperAdmin()) {
        return <Redirect to="/farmmanagement" />;
      } else {
        return <Redirect to="/subFarmsList" />;
      }
    }
    return (
      <SubFarmForm
        farmInfo={this.props.selectedFarm}
        formLabel="Edit Sub Farm"
        buttonLabel="Update"
        handleSubmit={this.handleSubmit}
        MainFarmName={this.getMainFarmName(this.props.MainFarmId)}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedFarm: state.FarmManagementReducer.selectedFarm,
    farmUpdated: state.FarmManagementReducer.farmUpdated,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    MainFarmsList: state.FarmManagementReducer.MainFarmsList
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ farmUpdateAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditSubFarm);



// WEBPACK FOOTER //
// ./src/components/private/FarmManagment/EditSubFarm.js